import { WeatherData } from "../../../../../../../store/reducers/weather";
import { XAxisOptions } from "highcharts";
import { isEqual } from "lodash";
import ReactDOMServer from "react-dom/server";
import { WeatherIcon } from "../../index";
import React from "react";
import { startOfDay } from "date-fns";

export const getWeatherLabels = (weatherByPeriod?: WeatherData[]): XAxisOptions => {
    return {
        offset: 20,
        tickWidth: 0,
        lineWidth: 0,
        opposite: true,
        linkedTo: 0,
        labels: {
            autoRotation: undefined,
            align: "right",
            x: 20,
            useHTML: true,
            formatter: function (point) {
                const weather: WeatherData | undefined = weatherByPeriod?.find(x => isEqual(startOfDay(x.date), startOfDay(point.pos)))
                return ReactDOMServer.renderToString(<WeatherIcon data={weather} />)
            },
        },
    }
}